// src/client-admin/js/hooks/useApi.ts
import { useEffect, useRef } from 'react';
import axios, { AxiosInstance } from 'axios';
import { useAuthentication } from '../contexts/AuthenticationContext';

export const useApi = (): AxiosInstance => {
    const { accessToken } = useAuthentication();
    const apiRef = useRef<AxiosInstance | null>(null);

    // Create the API instance if it doesn't exist
    if (!apiRef.current) {
        apiRef.current = axios.create({
            baseURL: '/api',
            withCredentials: true,
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0'
            }
        });
    }

    // Set up the token interceptor
    useEffect(() => {
        const api = apiRef.current!;

        // Request interceptor for adding the auth token
        const interceptorId = api.interceptors.request.use(
            config => {
                // Add the token to the Authorization header if we have one
                if (accessToken) {
                    config.headers.Authorization = `Bearer ${accessToken}`;
                }
                return config;
            },
            error => Promise.reject(error)
        );

        // Clean up the interceptor when the component unmounts or the token changes
        return () => {
            api.interceptors.request.eject(interceptorId);
        };
    }, [accessToken]);

    return apiRef.current!;
};